import { render } from "./Jouer.vue?vue&type=template&id=4c9b56d3"
import script from "./Jouer.vue?vue&type=script&lang=js"
export * from "./Jouer.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__